import React from 'react';
import { Headset, BadgeCheck } from 'lucide-react';
import 'aos/dist/aos.css';
import img1 from '../../assets/images/automobile-2861859_1280.jpg'

const AboutUs = () => {
  return (
    <section
      className="py-20 px-6 md:px-10"
      style={{ backgroundColor: "#F1F0EA", color: "#534B52" }}
    >
      <div className="max-w-6xl mx-auto text-center">
        {/* Centered Image */}
        <div data-aos="fade-up" className="mb-10 flex justify-center">
        <img
            src={img1}
            alt="Highlight"
            className="rounded-lg shadow-xl w-full h-auto max-w-[1000px]"
            style={{ height: "auto", width: "100%" }} // Double width from original
          />
        </div>

        {/* Section Title */}
        <div data-aos="fade-up" className="mb-12">
          <h2 className="text-4xl font-bold mb-4" style={{ color: "#474448" }}>
            Powder Coating Process
          </h2>
          <p className="text-xl" style={{ color: "#534B52" }}>
            We Enhance/decorate Your Surfaces with Expert Powder Coating.
          </p>
        </div>

        {/* Company Overview */}
        <div data-aos="fade-up" className="mb-16 text-lg leading-relaxed">
          <p>
            Powder coating is a dry finishing process in which a free-flowing
            powder is applied to a surface. Unlike traditional liquid paint,
            powder coating does not require a solvent to suspend the binder and
            filler components in a liquid form.
          </p>
        </div>

        {/* Highlights with Icons - You can add these here if needed */}
      </div>
    </section>
  );
};

export default AboutUs;
